/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type ConversationTopicFilterConfigColumn =
  (typeof ConversationTopicFilterConfigColumn)[keyof typeof ConversationTopicFilterConfigColumn];

export const ConversationTopicFilterConfigColumn = {
  conversation_topic: 'conversation_topic',
} as const;
